import { useContext, useEffect } from 'react';
import { AppContext } from '../../../main/context/Provider';
import withFilteredQueryRequest from '../../shared/components/table/withFilteredRequest';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { AddButton } from '../../shared/components/AddButton';
import { Private_Routes } from '../../../main/constants';
import ProjectMilestoneTable from '../components/ProjectMilestoneTable';

export const ProjectMilestonePage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const ProjectMilestoneList = withFilteredQueryRequest(
        'project-milestone/project-milestone-filtered-list',
        ProjectMilestoneTable
    );

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Hitos');

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Fases - Hitos',
                route: Private_Routes.PROJECT_MILESTONE_PAGE,
            },
        ]);
    }, [lang]);

    return (
        <div className='row'>
            <div className='col-12'>
                <div className='card'>
                    <div className='card-body'>
                        <div className='mb-3'>
                            <AddButton
                                href={Private_Routes.CREATE_PROJECT_MILESTONE}
                            />
                        </div>
                        <ProjectMilestoneList />
                    </div>
                </div>
            </div>
        </div>
    );
};
